import React, { useEffect, useState } from 'react';
import Image, { ImageProps }          from 'next/image'

import placeHolderImage from '../../../../public/images/placeholder-600x300.jpg'


interface Props extends ImageProps {
    fallbackSrc?: string;
    alt?: string;
    onClick?: () => void;
}

export const CImage: React.FC<Props> = (props) => {

    const { src, fallbackSrc, alt, onClick, ...rest } = props;

    const [imgSrc, setImgSrc] = useState(src);

    useEffect(() => {
        setImgSrc(src);
    }, [src]);


    return (
        <Image
            {...rest}
            src={imgSrc}
            alt={alt}
            onLoadingComplete={(result) => {
                if (result.naturalWidth === 0) {
                    setImgSrc(fallbackSrc || placeHolderImage);
                }
            }}
            onError={() => {
                setImgSrc(fallbackSrc || placeHolderImage);
            }}
            onClick={onClick}
        />
    );

}
